import React, { useContext } from "react";
import dayjs from "dayjs";
import { TalkRooms } from "../lib/types";

import { Box } from "../../../shared/components/ui/chakra";
import { Avatar, HStack, Stack, Text, Circle } from "@chakra-ui/react";
import { FlipperContext } from "../../../../shared/lib/FlipperContext";

const TalkMessageListItem = ({
  last_sent_at,
  onClick,
  partner,
  isActive,
  unread,
}: {
  last_sent_at: string;
  onClick: () => void;
  isActive: boolean;
  partner: TalkRooms[number]["partner"];
  unread: boolean;
}) => {
  const flipper = useContext(FlipperContext);

  return (
    <HStack
      gap={3}
      p={3}
      borderRadius={8}
      bgColor={isActive ? "brand.50" : "white"}
      _hover={{
        bgColor: "brand.50",
      }}
      transitionDuration={"0.2s"}
      transitionTimingFunction={"ease-in-out"}
      onClick={onClick}
    >
      <Box w={12} flexShrink={0} position="relative">
        <Avatar size="full" src={partner.image_url} />
        {flipper.show_unread_budge && unread && (
          <Circle
            size="15px"
            bg="red.500"
            position="absolute"
            top="0"
            right="0"
            border="1px solid white"
            data-testid="unread-budge"
          />
        )}
      </Box>
      <Stack gap={0}>
        <Text fontSize={"sm"}>{partner.name}</Text>
        <Text fontSize="xs" noOfLines={2} color={"textGray"}>
          {dayjs(last_sent_at).format("LLL")}
        </Text>
      </Stack>
    </HStack>
  );
};

export default TalkMessageListItem;
